module.exports = __webpack_public_path__ + "fonts/futura-t-medium.af140c93.ttf";